<template>
  <div class="list-table" :key="keyComponent">
    <template v-if="!thereIsData">
      <div class="spinner">
        <Loading size="200" />
      </div>
    </template>
    <template>
      <b-modal
        ref="modal-list-table-content"
        hide-footer
        :title="subjectByIndex"
        scrollable
      >
        <p class="my-4">{{ contentByIndex }}</p>
      </b-modal>
    </template>
    <template v-if="thereIsData">
      <b-container fluid>
        <b-tabs
          v-if="currentDepartment.department_id == 2"
          content-class="mt-3"
          fill
          lazy
        >
          <b-tab
            v-for="(queueName, index) in queueNames"
            :key="queueName"
            :active="queueNamesActive[index]"
            :title="queueName"
            @click="changeQueue(queueName)"
          >
          </b-tab>
        </b-tabs>
        <b-tabs
          v-if="validationComponent('alertTabs')"
          content-class="mt-3"
          fill
          lazy
        >
          <b-tab
            v-for="alertOption in alertNames"
            :key="alertOption"
            :title="alertOption"
            @click="changeQueue(alertOption)"
          >
          </b-tab>
        </b-tabs>
        <div class="list-table__mobile-buttons">
          <b-form-group
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="
              list-table__mobile-buttons__form
              mb-0
              d-none d-sm-block d-md-none d-block d-sm-none
            "
          >
            <b-input-group size="sm">
              <b-form-input
                aria-label="Type here what you want to search in the list of pending quotes"
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              >
              </b-form-input>
              <b-input-group-append>
                <b-button
                  aria-label="Click here to clean the search input"
                  class="list-table__mobile-buttons__form--clear-button"
                  :disabled="!filter"
                  @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
            <div class="list-table__mobile-buttons__form__buttons">
              <b-overlay
                :show="creating"
                rounded
                opacity="0.6"
                spinner-small
                class="d-inline-block mr-4"
                v-if="validationComponent('createQuoteButton')"
              >
                <b-button
                  v-b-modal.modal-subject
                  :disabled="creating"
                  ref="button-delete"
                  class="list-table__table__header__buttons--delete mb-2"
                  size="sm"
                  ><span>
                    <i class="fa fa-plus mr-1"></i>Create
                  </span></b-button
                >
              </b-overlay>
              <b-overlay
                :show="deleting"
                rounded
                opacity="0.6"
                spinner-small
                class="d-inline-block"
              >
                <b-button
                  v-if="$route.path !== '/hypercubes'"
                  aria-label="Click here to delete the selected quotes"
                  @click="changeStatus"
                  :disabled="deleting"
                  ref="button-delete"
                  class="list-table__mobile-buttons__form__buttons--delete mb-2"
                  size="sm"
                  ><span v-if="$route.path == '/deleted'">Send to Queue</span
                  ><span v-else>Delete</span></b-button
                >
              </b-overlay>
              <b-overlay
                :show="unassigning"
                rounded
                opacity="0.6"
                spinner-small
                class="d-inline-block"
              >
                <b-button
                  v-if="allowedRoutesUnassign.includes($route.path)"
                  @click="unassign"
                  :disabled="unassigning"
                  ref="button-unassign"
                  aria-label="Click here to delete the selected quotes"
                  class="list-table__mobile-buttons__form__buttons--unassign mb-2"
                  size="sm"
                  >Unassign</b-button
                >
              </b-overlay>
              <b-form-group
                v-if="currentDepartment.department_id == 1"
                class="list-table__mobile-buttons ml-2"
              >
                <el-tooltip
                  :content="
                    `Auto-assign status: ${
                      statusAutoassigner ? 'Active' : 'Inactive'
                    }`
                  "
                  placement="top"
                >
                  <b-form-checkbox
                    size="sm"
                    disabled
                    v-model="statusAutoassigner"
                    name="check-button"
                    switch
                  >
                  </b-form-checkbox>
                </el-tooltip>
              </b-form-group>
            </div>
          </b-form-group>
        </div>

        <div
          v-if="currentDepartment.department_id != 2"
          sm="7"
          md="6"
          class="list-table__pagination"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
            @change="paginate"
            aria-controls="items"
            last-number
          >
          </b-pagination>
        </div>
        <b-table
          id="items"
          show-empty
          hover
          class="list-table__table"
          head-variant="light"
          stacked="lg"
          :key="renderTable"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :busy="isBusy"
          @row-clicked="clickRow"
        >
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner
                class="align-middle"
                aria-label="Loading table"
              ></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:thead-top="data">
            <SubjectModal
              :departmentId="parseInt(currentDepartment.department_id)"
              @updateSubject="addQuote"
            />
            <b-tr v-bind:key="data.columns">
              <b-th variant="dark" :colspan="colspan">
                <b-row>
                  <b-col class="list-table__table__header__buttons">
                    <div
                      v-if="
                        user[0].rol.name === 'quoter' &&
                          $route.params.pathName === 'myQueue' &&
                          currentDepartment.department_name !== 'ltl'
                      "
                    >
                      <b-overlay
                        rounded
                        opacity="0.6"
                        spinner-small
                        class="d-inline-block mr-4"
                      >
                        <b-button
                          v-b-modal.modal-subject
                          class="list-table__table__header__buttons--delete mb-2"
                          size="sm"
                          ><span>
                            <i class="fa fa-plus mr-1"></i>Create
                          </span></b-button
                        >
                      </b-overlay>
                    </div>
                    <b-overlay
                      :show="creating"
                      rounded
                      opacity="0.6"
                      spinner-small
                      class="d-inline-block mr-4"
                      v-if="validationComponent('createQuoteButton')"
                    >
                      <b-button
                        v-b-modal.modal-subject
                        :disabled="creating"
                        ref="button-delete"
                        class="list-table__table__header__buttons--delete mb-2"
                        size="sm"
                        ><span>
                          <i class="fa fa-plus mr-1"></i>Create
                        </span></b-button
                      >
                    </b-overlay>

                    <b-overlay
                      :show="deleting"
                      rounded
                      opacity="0.6"
                      spinner-small
                      class="d-inline-block mr-2"
                    >
                      <b-button
                        v-if="$route.path !== '/hypercubes'"
                        @click="changeStatus"
                        :disabled="deleting"
                        ref="button-delete"
                        class="list-table__table__header__buttons--delete mb-2"
                        size="sm"
                        ><span v-if="$route.path == '/deleted'"
                          >Send to Queue</span
                        ><span v-else>Delete</span></b-button
                      >
                    </b-overlay>
                    <b-overlay
                      :show="changingStatusSent"
                      rounded
                      opacity="0.6"
                      spinner-small
                      class="d-inline-block mr-2"
                    >
                      <b-button
                        v-if="
                          $route.path !== '/hypercubes' &&
                            $route.path === '/alerts'
                        "
                        @click="setAlertToSent"
                        :disabled="changingStatusSent"
                        ref="button-send-alert"
                        class="list-table__table__header__buttons--delete mb-2"
                        size="sm"
                        ><span>Send Alert to Sent</span></b-button
                      >
                    </b-overlay>

                    <b-overlay
                      :show="sendingToNonLTL"
                      rounded
                      opacity="0.6"
                      spinner-small
                      class="d-inline-block mr-2"
                      v-if="validationComponent('sendToNonButton')"
                    >
                      <b-button
                        @click="sendToNonLTL"
                        :disabled="sendingToNonLTL"
                        ref="button-sendNonLTL"
                        class="list-table__table__header__buttons--delete mb-2"
                        size="sm"
                        ><span
                          >Send to Non {{ nameDepartment.toUpperCase() }}</span
                        ></b-button
                      >
                    </b-overlay>

                    <b-overlay
                      :show="sendingToQueue"
                      rounded
                      opacity="0.6"
                      spinner-small
                      class="d-inline-block mr-2"
                      v-if="$route.path === '/unknown'"
                    >
                      <b-button
                        @click="sendToQueue"
                        :disabled="sendingToQueue"
                        ref="button-sendToQueue"
                        class="list-table__table__header__buttons--delete mb-2"
                        size="sm"
                        ><span>Send to queue</span></b-button
                      >
                    </b-overlay>

                    <b-overlay
                      :show="assigning"
                      rounded
                      opacity="0.6"
                      spinner-small
                      class="d-inline-block"
                      v-if="validationComponent('multipleAssignButton')"
                    >
                      <b-button
                        @click="multipleAssign('assign')"
                        :disabled="assigning"
                        ref="button-sendToQueue"
                        class="list-table__table__header__buttons--delete mb-2"
                        size="sm"
                        ><span>Assign</span></b-button
                      >
                    </b-overlay>

                    <b-overlay
                      :show="unassigning"
                      rounded
                      opacity="0.6"
                      spinner-small
                      class="d-inline-block mr-2"
                    >
                      <b-button
                        v-if="allowedRoutesUnassign.includes($route.path)"
                        @click="unassign"
                        :disabled="unassigning"
                        ref="button-unassign"
                        aria-label="Click here to delete the selected quotes"
                        class="list-table__table__header__buttons--unassign mb-2"
                        size="sm"
                        >Unassign</b-button
                      >
                    </b-overlay>
                    <b-form-group
                      v-if="currentDepartment.department_id == 1"
                      class="list-table__table__header__buttons mb-2"
                    >
                      <el-tooltip
                        :content="
                          `Auto-assign status: ${
                            statusAutoassigner ? 'Active' : 'Inactive'
                          }`
                        "
                        placement="top"
                      >
                        <b-form-checkbox
                          size="sm"
                          class="list-table__table__header"
                          disabled
                          v-model="statusAutoassigner"
                          name="check-button"
                          switch
                        >
                        </b-form-checkbox>
                      </el-tooltip>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label-cols-sm="3"
                      label-align-sm="right"
                      label-size="sm"
                      label-for="filterInput"
                      class="mb-0"
                    >
                      <b-overlay
                        :show="searching"
                        rounded
                        opacity="0.2"
                        spinner-small
                      >
                        <b-input-group size="sm">
                          <b-form-input
                            v-on:keyup.enter="searchQuote"
                            aria-label="Type here what you want to search in the list of pending quotes"
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Type to Search"
                            autocomplete="off"
                          >
                          </b-form-input>
                          <b-input-group-append>
                            <b-button
                              class="list-table__table__header--clear-button"
                              :disabled="!filter"
                              @click="filter = ''"
                              >Clear</b-button
                            >
                          </b-input-group-append>
                        </b-input-group>
                      </b-overlay>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-th>
            </b-tr>
          </template>

          <template v-slot:head(actions)="column">
            <b-form-checkbox
              :id="column.index"
              v-model="areAllSelected"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(actions)="row">
            <b-form-checkbox
              :id="'row' + row.index"
              v-model="isChecked[row.index]"
              name="select-row"
              value="accepted"
              unchecked-value="not_accepted"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(subject)="row">
            <div class="list-table__table__content">
              <span :key="row.label">
                {{ items[row.index].subject }}
              </span>
              <b-button
                v-if="items[row.index].content"
                class="list-table__table__button-modal-list-table"
                variant="outline-info"
                pill
                :id="items[row.index].id"
                title="Preview"
                @click="
                  hideModal(items[row.index].subject, items[row.index].content)
                "
              >
                <i class="fas fa-angle-double-down"></i>
              </b-button>
            </div>
          </template>
          <template
            v-if="
              $route.params.pathName == 'sent' ||
                $route.params.pathName == 'failed' ||
                $route.params.pathName == 'alerts'
            "
            v-slot:cell(shp)="row"
          >
            <span v-if="items[row.index].shp" :key="row.label">{{
              items[row.index].shp.join(", ")
            }}</span>
          </template>

          <template v-slot:cell(customers)="row">
            <CustomerTable
              :key="renderAssignTo"
              :infoCustomer="items[row.index].customer_id"
              :rowInfo="items[row.index]"
              :infoUsername="user[0].user.username"
            />
          </template>

          <template v-slot:cell(client_email)="row">
            <span v-if="items[row.index].client_email" :key="row.label">{{
              items[row.index].client_email.replaceAll(",", ", ")
            }}</span>
            <span v-else :key="row.label"></span>
          </template>

          <template v-slot:cell(language_classification)="row">
            <span :key="row.label">
              {{ items[row.index].language_classification }}
            </span>
          </template>

          <template v-slot:cell(created_at)="row">
            <span :key="row.label">
              {{ items[row.index].created_at | formatDate }}
            </span>
          </template>

          <template v-slot:cell(last_modified)="row">
            <span :key="row.label">
              {{ items[row.index].last_modified | formatDate }}
            </span>
          </template>
          <template v-slot:cell(canned_response)="row">
            <CannedResponseTable
              v-if="responsesCanned"
              :key="renderAssignTo"
              :rowInfo="items[row.index]"
              @cannedResponseId="cannedResponseId"
              :infoUsername="user[0].user.username"
              :responsesCanned="responsesCanned"
            />
          </template>
          <!-- ModeTable component not in use -->
          <template v-slot:cell(mode)="row">
            <div class="autocompletes-container__mode">
              <ModeTable
                :key="renderAssignTo"
                :disabled="disabledCustomer"
                :infoRow="items[row.index]"
                :infoMode="items[row.index].tms_mode"
                :index="row.index"
              />
            </div>
          </template>

          <template v-slot:cell(assigned_to)="row">
            <AssignTo
              :key="renderAssignTo"
              v-if="validationComponent('assignToButton', row.index)"
              :rowInfo="items[row.index]"
              @assignToSelected="assignToSelected"
              :availableUsers="availableUsers"
            />
            <div v-else class="list-table__table__assign-to">
              <span
                class="list-table__table__assign-to--assigned-to"
                :id="items[row.index].id"
                ><span :key="keyUser"
                  ><i class="fa fa-user-tag"></i>
                  {{ userAssigned[row.index] }}</span
                ></span
              >
              <b-button
                v-if="validationComponent('assignMeButton', row.index)"
                title="Assign me"
                class="list-table__table__assign-to--assigned-me"
                @click="assignMe(items[row.index].id, 'assign')"
                ><i class="fas fa-house-user"></i
              ></b-button>
            </div>
          </template>

          <template v-slot:cell(cause_of_return)="row">
            <div
              v-if="items[row.index].message_alert"
              class="list-table__column"
            >
              <span
                v-for="(alert, index) in items[row.index].message_alert"
                :key="index"
              >
                {{ alert }}.
              </span>
            </div>
            <span v-else :key="row.label">
              {{ items[row.index].description_not_quote }}.
            </span>
          </template>

          <template v-slot:cell(send_to_hypercubes)="row">
            <div class="list-table__table__assign-hypercubes">
              <b-button
                v-if="
                  rolConditionTable(user, items[row.index], $route.path) &&
                    currentDepartment.department_id == 1
                "
                class="list-table__table__button-hypercubes"
                :id="items[row.index].id"
                title="Send to"
                @click="
                  sendToHypercubes(
                    items[row.index].id,
                    items[row.index].quote_id,
                    row.index
                  )
                "
              >
                <b-spinner
                  v-show="spinnerByIndex.index == row.index"
                  small
                ></b-spinner>
                Send to <i class="fas fa-cube"></i>
              </b-button>
            </div>
          </template>
        </b-table>

        <div sm="7" md="6" class="list-table__pagination">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
            @change="paginate"
            aria-controls="items"
            last-number
          >
          </b-pagination>
        </div>
      </b-container>
    </template>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import { fieldsTable, fields } from "@/utils/listTable.js";
import { mapState, mapGetters } from "vuex";
import CustomerTable from "@/views/InfoEmail/shared/CustomerTable";
import ModeTable from "@/views/InfoEmail/LTL/ModeTable.vue";
import AssignTo from "@/views/InfoEmail/LTL/AssignTo.vue";
import CannedResponseTable from "@/views/InfoEmail/LTL/CannedResponseTable.vue";
import { missingFieldsAlert, errorAlert } from "@/api/errorMessages";
import swal from "sweetalert";
import {
  listTableCondition,
  validateComponents,
  validateTableComponents,
  validateRoutes
} from "@/mixins/infoEmail/validateQuote";
import SubjectModal from "@/views/InfoEmail/shared/SubjectModal.vue";

export default {
  name: "ListTable",
  components: {
    Loading,
    CustomerTable,
    ModeTable,
    AssignTo,
    CannedResponseTable,
    SubjectModal
  },
  data() {
    return {
      items: [],
      fields: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      status: "not_accepted",
      selectedRows: [],
      auxColumn: null,
      auxindex: null,
      auxEvent: null,
      isChecked: [],
      areAllSelected: "not_accepted",
      pathNames: {
        myQueue: 2,
        queue: 2,
        "spanish-queue": 2,
        inProcess: 3,
        hypercubes: 11,
        alerts: 10,
        failed: 4,
        sent: 5,
        unknown: 2,
        deleted: 8
      },
      allowedRoutesUnassign: ["/myQueue"],
      userAssigned: [],
      user: null,
      keyUser: 0,
      selectedUser: [],
      infoUser: null,
      thereIsData: false,
      isBusy: false,
      unassigning: false,
      deleting: false,
      sendingToNonLTL: false,
      sendingToQueue: false,
      assigning: false,
      searching: false,
      isSearched: false,
      colspan: 8,
      canBeReloaded: true,
      renderTable: 50,
      disabledCustomer: null,
      cannedResponseIdSelected: {},
      goSendHypercubes: false,
      spinnerByIndex: { index: null },
      renderAssignTo: 0,
      availableUsers: null,
      responsesCanned: null,
      creating: false,
      changingStatusSent: false,
      queueNames: ["OTR", "Drayage"],
      queueNamesActive: [],
      alertNames: ["Alerts", "Alerts assigned"],
      alertName: null,
      currentDepartment: null,
      actualQueue: null,
      nameDepartment: null,
      contentByIndex: null,
      subjectByIndex: null,
      statusAutoassigner: false,
      hideOptions: false
    };
  },
  watch: {
    areAllSelected: function() {
      for (let item in this.items) {
        if (this.areAllSelected === "accepted") {
          this.isChecked[item] = "accepted";
        } else if (this.areAllSelected === "not_accepted") {
          this.isChecked[item] = "not_accepted";
        }
      }
    },
    "$route.path": async function() {
      this.canBeReloaded = false;
      this.getFields();
      if (this.$route.params.pathName == "alerts") {
        this.alertName = "Alerts";
      }
      await this.getCannedResponses();
      await this.reloadTable();
      this.filter = null;
    },
    filter: async function() {
      if (this.filter == "") {
        await this.reloadTable();
        this.isSearched = false;
      }
    },
    //Revisar si este keyComponent si es necesario de lo contrario borrar
    async keyComponent() {
      if (this.canBeReloaded) {
        await this.reloadTable();
      }
      this.canBeReloaded = true;
    },
    async showInfoDepartment(value) {
      this.currentDepartment = value;
      this.getFields();
      this.setActualQueue();
      if (this.currentDepartment.department_id == 2) {
        this.setActiveTab();
      }
      this.getNameDepartment();
      this.canBeReloaded = false;
      await this.reloadTable();
      this.filter = null;
    },
    showAutoassignerData() {
      this.statusAutoassigner = this.showAutoassignerData[0]?.is_active;
      this.hidingOptions();
    },
    async showNotificationAutoassigner() {
      const assignedUser = this.showNotificationAutoassigner?.users_assigned?.some(
        userId => userId === this.user[0]?.user?.id
      );
      if (this.$route?.params?.pathName === "myQueue" && assignedUser) {
        await this.reloadTable();
      }
    }
  },
  computed: {
    ...mapState({ keyComponent: state => state.quotes.keyComponent }),
    ...mapGetters("login", ["showInfoDepartment"]),
    ...mapGetters("quotes", ["showActualQueue"]),
    ...mapGetters("usersManagement/autoassigner", ["showAutoassignerData"]),
    ...mapGetters("usersManagement/autoassigner", [
      "showNotificationAutoassigner"
    ])
  },
  async created() {
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    this.currentDepartment = this.showInfoDepartment;
    this.setActualQueue();
    this.getNameDepartment();
    this.setActiveTab();
    this.alertName = "Alerts";
    await this.getAvailableUsers();
    await this.getCannedResponses();
    this.hidingOptions();
  },
  async mounted() {
    this.infoUser = this.$store.getters["login/showUserLoggedIn"];
    await this.getTotalQuotes();
    await this.getQuotes();
    this.thereIsData = true;
    this.setColor();
    this.getFields();
    this.addShpColumn();
  },
  methods: {
    getFields() {
      if (this.currentDepartment.department_id == 1) {
        this.colspan = 9;
        this.fields = [...fieldsTable];
        this.fields = this.renderFields();
      } else {
        this.fields = [...fields];
        this.fields = this.fields.filter(field => field.key !== "created_at");
      }
    },
    renderFields() {
      let arrayRenderFields;
      this.renderFieldsDisable();
      if (this.$route.path == "/hypercubes") {
        this.fields = this.fields.filter(field => field.key !== "actions");
      }
      if (
        (this.user[0].rol.id == 2 && this.$route.path !== "/myQueue") ||
        (this.user[0].rol.id == 3 &&
          this.$route.path !== "/queue" &&
          this.$route.path !== "/spanish-queue" &&
          this.$route.path !== "/alerts")
      ) {
        let fieldsCondition = [
          "CANNED RESPONSE",
          "SEND TO HYPERCUBES",
          "MODE",
          "CUSTOMERS",
          "CAUSE OF RETURN MAIL"
        ];
        arrayRenderFields = this.fields.filter(
          field => !fieldsCondition.includes(field.label)
        );
        return arrayRenderFields;
      }
      if (this.$route.path == "/alerts") {
        this.fields = this.fields.filter(
          field =>
            field.key == "actions" ||
            field.label == "ID" ||
            field.label == "SUBJECT" ||
            field.label == "CREATED AT" ||
            field.key == "assigned_to" ||
            field.user == "cause_of_return"
        );
        if (this.items) {
          return this.fields;
        }
      } else {
        this.fields = this.fields.filter(field => field.user == "superUser");
        return this.fields;
      }
    },
    renderFieldsDisable() {
      if (this.user[0].rol.id == 3 && this.$route.path !== "/queue") {
        this.disabledCustomer = true;
      } else {
        this.disabledCustomer = false;
      }
    },
    async clickRow(item, index, event) {
      this.auxindex = index;
      this.auxEvent = event;
      if (event.target.tagName.toLowerCase() != "li") {
        if (this.$route.path === "/deleted" && !item.quote_id) {
          await swal({
            title: "Information",
            text: "This email cannot be opened because it has not been categorized as a quote yet. Please send it to the main queue so it can be categorized as a quote.",
            icon: "warning"
          });
          return;
        }
        let pathAux = this.$route.path;
        let path = pathAux.substring(1, pathAux.length);
        if (this.$route.params.pathName == "unknown") {
          this.$router.push({
            name: "NonQuote",
            params: { pathName: "unknown", id: item.id }
          });
        } else {
          this.$router.push({
            name: "InfoEmail",
            params: { pathName: path, id: item.quote_id }
          });
        }
      }
    },
    async reloadTable() {
      this.thereIsData = false;
      this.currentPage = 1;
      this.isSearched = false;
      this.isBusy = true;
      try {
        await this.getTotalQuotes();
        await this.getQuotes();
        this.addShpColumn();
        this.thereIsData = true;
        this.isBusy = false;
        this.setColor();
        this.canBeReloaded = true;
        this.hidingOptions();
      } catch (error) {
        this.isBusy = false;
      }
    },
    addShpColumn() {
      const routes = ["sent", "failed", "alerts"];
      let shp = {
        key: "shp",
        label: "SHP"
      };
      let thereIsShp = false;
      if (validateRoutes(routes, this.$route.params.pathName)) {
        for (let i = 0; i < this.fields.length; i++) {
          if (this.fields[i].key == "shp") {
            thereIsShp = true;
          }
        }
        if (!thereIsShp) {
          this.fields.splice(2, 0, shp);
          this.colspan += 1;
          this.renderTable += 1;
        }
      }
    },
    async changeStatus() {
      this.deleting = true;
      if (this.$route.path == "/deleted") {
        let info = {};
        info.quotes = [];
        let changeStatusResponse;
        if (this.areAllSelected === "accepted") {
          this.areAllSelected = "not_accepted";
          for (let item of this.items) {
            info.quotes.push(item.id);
          }
          changeStatusResponse = await this.$store.dispatch("quotes/changeStatus", info);
        } else {
          for (let i in this.items) {
            if (this.isChecked[i] == "accepted") {
              info.quotes.push(this.items[i].id);
              this.isChecked[i] = "not_accepted";
            }
          }
          changeStatusResponse = await this.$store.dispatch("quotes/changeStatus", info);
        }
        const errData = JSON.stringify(changeStatusResponse?.data || "");
        if (
          errData.includes(
            "cannot be processed because not meet the requirements to be sent to queue"
          )
        ) {
          const errText =
            typeof changeStatusResponse.data === "string"
              ? changeStatusResponse.data
              : changeStatusResponse.data?.detail ||
                changeStatusResponse.data?.error ||
                JSON.stringify(changeStatusResponse.data);
          await swal({
            title: "Error",
            text: errText,
            icon: "error",
            button: "OK"
          });
        }
        await this.getTotalQuotes();
        await this.getQuotes();
        this.setColor();
      } else {
        let quotes = [];
        if (this.areAllSelected === "accepted") {
          this.areAllSelected = "not_accepted";
          for (let item of this.items) {
            let user = this.$store.getters["login/showUserLoggedIn"].username;
            if (user == item.assigned_to) {
              quotes.push(item.id);
            } else {
              if (this.$route.path != "queue") {
                quotes.push(item.id);
              }
            }
          }
        } else {
          for (let i in this.items) {
            if (this.isChecked[i] == "accepted") {
              let user = this.$store.getters["login/showUserLoggedIn"].username;
              if (user == this.items[i].assigned_to) {
                quotes.push(this.items[i].id);
              } else {
                if (this.$route.path != "/queue") {
                  quotes.push(this.items[i].id);
                }
              }
              this.isChecked[i] == "not_accepted";
            }
          }
        }
        let response = await this.$store.dispatch(
          "quotes/deleteQuotes",
          quotes
        );
        if (response.status == 204) {
          await this.getTotalQuotes();
          await this.getQuotes();
          this.setColor();
        }
      }
      this.areAllSelected = "not_accepted";
      this.deleting = false;
    },
    async sendToNonLTL() {
      this.sendingToNonLTL = true;
      if (this.areAllSelected === "accepted") {
        this.areAllSelected = "not_accepted";
        for (let item of this.items) {
          await this.$store.dispatch("quotes/quote/sendToNonQuote", item);
        }
      } else {
        for (let i in this.items) {
          if (this.isChecked[i] == "accepted") {
            await this.$store.dispatch(
              "quotes/quote/sendToNonQuote",
              this.items[i].id
            );
            this.isChecked[i] = "not_accepted";
          }
        }
      }
      this.sendingToNonLTL = false;
      await this.getTotalQuotes();
      await this.getQuotes();
      this.setColor();
    },
    async sendToQueue(assignButton) {
      let info = {};
      info.quotes = [];
      info.assignButton = assignButton;
      if (assignButton === "assign") {
        this.assigning = true;
      } else {
        this.sendingToQueue = true;
      }
      if (this.areAllSelected === "accepted") {
        this.areAllSelected = "not_accepted";
        for (let item of this.items) {
          info.quotes.push(item.id);
        }
        await this.$store.dispatch("quotes/changeStatus", info);
      } else {
        for (let i in this.items) {
          if (this.isChecked[i] == "accepted") {
            info.quotes.push(this.items[i].id);
            this.isChecked[i] = "not_accepted";
          }
        }
        await this.$store.dispatch("quotes/changeStatus", info);
      }
      this.sendingToQueue = false;
      this.assigning = false;
      await this.getTotalQuotes();
      await this.getQuotes();
      this.setColor();
    },
    async sendToHypercubes(id, quoteId, indexRow) {
      this.spinnerByIndex.index = indexRow;
      let { data } = await this.$store.dispatch(
        "quotes/quote/getQuote",
        quoteId
      );
      let validation = data.haul;
      for (let haul of validation) {
        if (
          haul.customer_id === null ||
          haul.customer_id === "" ||
          haul.customer_id === undefined
        ) {
          this.goSendHypercubes = false;
          break;
        } else {
          this.goSendHypercubes = true;
        }
      }
      let info = {};
      info.id = id;
      let cannedResponseIdExists = id in this.cannedResponseIdSelected;
      if (this.goSendHypercubes) {
        if (
          !cannedResponseIdExists ||
          this.cannedResponseIdSelected[id] === null
        ) {
          missingFieldsAlert("Please, select a canned response!");
        } else {
          info.canned_id = this.cannedResponseIdSelected[id];
          let response = await this.$store.dispatch(
            "quotes/sendHyperCubes",
            info
          );
          if (!response) {
            this.swal({
              icon: "success",
              title: "Success",
              text: "Your quote has been sent",
              buttons: false,
              timer: 1000
            });
            await this.reloadTable();
          } else if (response.status == 422) {
            errorAlert(
              "Error",
              "Please check the field information on all trips."
            );
          } else if (response.status == 400) {
            errorAlert("There is something wrong", response.data.detail.detail);
          } else if (response.status == 404) {
            errorAlert("There is something wrong", response.data.detail.detail);
          }
        }
        this.goSendHypercubes = false;
      } else {
        missingFieldsAlert("Customer field is required in all trips.");
      }
      this.spinnerByIndex.index = null;
    },
    async assignMe(id, assignButton) {
      if (this.$route.params.pathName === "unknown") {
        let info = {};
        info.quotes = [];
        info.assignButton = assignButton;
        info.quotes.push(id);
        await this.$store.dispatch("quotes/changeStatus", info);
        await this.getTotalQuotes();
        await this.getQuotes();
        this.setColor();
      } else {
        let info = {};
        info.message_id = id;
        let response = await this.$store.dispatch(
          "usersManagement/allocate/assignById",
          info
        );
        if (response.status == 200) {
          await this.getTotalQuotes();
          await this.getQuotes();
          this.setColor();
        }
        this.filter = "";
      }
    },
    async multipleAssign(assignButton) {
      if (this.$route.params.pathName === "unknown") {
        this.sendToQueue(assignButton);
      } else {
        this.assigning = true;
        let response;
        if (this.areAllSelected === "accepted") {
          this.areAllSelected = "not_accepted";
          for (let item of this.items) {
            let info = {};
            info.message_id = item.id;
            response = await this.$store.dispatch(
              "usersManagement/allocate/assignById",
              info
            );
          }
        } else {
          for (let i in this.items) {
            if (this.isChecked[i] == "accepted") {
              let info = {};
              info.message_id = this.items[i].id;
              response = await this.$store.dispatch(
                "usersManagement/allocate/assignById",
                info
              );
              this.isChecked[i] = "not_accepted";
            }
          }
        }
        if (response.status == 200) {
          await this.getTotalQuotes();
          await this.getQuotes();
          this.setColor();
        }
        this.filter = "";
        this.assigning = false;
      }
    },
    async unassign() {
      this.unassigning = true;
      let emailsToUnassign = [];
      for (let i in this.isChecked) {
        if (this.isChecked[i] == "accepted") {
          emailsToUnassign.push(this.items[i].id);
          this.isChecked[i] = "not_accepted";
        }
      }
      let info = {};
      info.message_id = emailsToUnassign;
      let response = await this.$store.dispatch(
        "usersManagement/allocate/unassignQuotes",
        info
      );
      this.unassigning = false;
      if (response.status == 200) {
        await this.getTotalQuotes();
        await this.getQuotes();
        this.setColor();
      }
    },
    async searchQuote() {
      this.isSearched = true;
      if (this.filter != "" && this.filter != null) {
        this.searching = true;
        let info = {};
        let routeName = this.$route.params.pathName;
        const routes = ["failed", "inProcess", "myQueue"];
        info.subject = this.filter;
        info.departmentId = this.currentDepartment.department_id;
        if (routeName === "unknown") {
          info.isQuote = false;
          info.charlieStatus = 2;
        } else {
          info.isQuote = true;
          info.charlieStatus = this.pathNames[routeName];
        }
        info.isRead = true;
        if (routeName === "deleted") {
          delete info.charlieStatus;
          delete info.isQuote;
          delete info.isRead;
          info.isDeleted = true;
        } else {
          info.isDeleted = false;
        }
        if (validateRoutes(routes, routeName)) {
          info.userId = this.$store.getters[
            "login/showUserLoggedIn"
          ][0].user.id;
        } else if (routeName === "queue") {
          if (this.currentDepartment.rol_name !== "superuser") {
            info.userId = "";
          }
        }
        if (
          (this.currentDepartment.rol_name === "superuser" &&
            this.$route.params.pathName === "queue") ||
          (this.currentDepartment.rol_name === "quoter" &&
            this.$route.params.pathName === "myQueue")
        ) {
          info.is_superuser = true;
        } else {
          info.is_superuser = false;
        }
        info.limit = 20;
        this.getEntryType(info);
        let response = await this.$store.dispatch("quotes/searchQuote", info);
        this.items = response.data;
        this.totalRows = 1;
        this.searching = false;
        this.renderTable += 1;
        this.setColor();
      }
    },
    async getTotalQuotes() {
      let info = {};
      let routeName = this.$route.params.pathName;
      const routes = ["deleted", "unknown", "myQueue"];
      info.status = this.pathNames[routeName];
      info.department = this.currentDepartment.department_id;
      this.getEntryType(info);
      if (routeName == "alerts") {
        this.getValidationAlert(info);
      }
      if (validateRoutes(routes, routeName)) {
        await this.$store.dispatch("quotes/getTotalQuotesAssigned", info);
      } else {
        if (
          (this.currentDepartment.rol_name === "quoter" &&
            routeName === "queue") ||
          (this.currentDepartment.rol_name === "quoter" &&
            routeName === "spanish-queue")
        ) {
          if (routeName === "spanish-queue") {
            info.language_classification = "es";
          }
          await this.$store.dispatch("quotes/getTotalUnassigned", info);
        } else {
          if (routeName === "spanish-queue") {
            info.language_classification = "es";
          }
          await this.$store.dispatch("quotes/getTotalQuotes", info);
        }
      }
      this.totalRows = this.$store.getters["quotes/showTotalQuotes"];
    },
    async getQuotes() {
      let userAux = localStorage.getItem("charlie-username-otr");
      this.user = JSON.parse(userAux);
      let info = {};
      info.page = (this.currentPage - 1) * this.perPage;
      info.department = this.currentDepartment.department_id;
      let routeName = this.$route.params.pathName;
      info.status = this.pathNames[routeName];
      if (
        (this.currentDepartment.rol_name === "superuser" &&
          this.$route.params.pathName === "queue") ||
        (this.currentDepartment.rol_name === "quoter" &&
          this.$route.params.pathName === "myQueue")
      ) {
        info.is_superuser = true;
      } else {
        info.is_superuser = false;
      }
      this.getEntryType(info);
      if (this.$route.params.pathName == "alerts") {
        this.getValidationAlert(info);
      }
      info.rol_name = this.currentDepartment.rol_name;
      if (routeName == "queue" || routeName === "spanish-queue") {
        if (routeName === "spanish-queue") {
          info.language_classification = "es";
        }
        info.currentDepartment = this.currentDepartment;
        if (this.currentDepartment.rol_name == "superuser") {
          await this.$store.dispatch("quotes/getQuotesNonDeletedMyQueue", info);
        } else {
          await this.$store.dispatch("quotes/getMainQueue", info);
        }
      } else {
        await this.$store.dispatch("quotes/getQuotesNonDeletedMyQueue", info);
      }
      this.items = this.$store.getters["quotes/showItems"];
      this.renderAssignTo += 1;
    },
    async paginate(e) {
      this.isBusy = true;
      this.currentPage = e;
      if (!this.isSearched) {
        await this.getQuotes();
      }
      this.isBusy = false;
      this.setColor();
      window.scrollTo(0, 0);
    },
    setColor() {
      this.userAssigned = [];
      for (let i in this.items) {
        if (!this.items[i].post_quotation_sent) {
          if (
            this.items[i].assigned_to != null &&
            this.items[i].assigned_to != "" &&
            this.items[i].assigned_to != "NotAllocate"
          ) {
            this.userAssigned[i] = this.items[i].assigned_to;
          } else {
            this.userAssigned[i] = "Not Assigned";
          }
        } else {
          this.userAssigned[i] = this.items[i].post_quotation_sent;
        }
        this.isChecked[i] = "not_accepted";
      }
      this.keyUser += 1;
    },
    async assignToSelected() {
      await this.getQuotes();
      this.setColor();
    },
    cannedResponseId(value) {
      this.cannedResponseIdSelected[value.emailId] = value.cannedResponsesId;
    },
    async getAvailableUsers() {
      if (this.user[0].rol.id === 3) {
        this.availableUsers = await this.$store.dispatch(
          "usersManagement/getAvailableUsers",
          this.currentDepartment.department_id
        );
      }
    },
    async getCannedResponses() {
      if (
        this.currentDepartment.department_id == 1 &&
        ((this.user[0].rol.id === 3 &&
          (this.$route.path === "/queue" ||
            this.$route.path === "/spanish-queue")) ||
          (this.user[0].rol.id === 2 && this.$route.path === "/myQueue"))
      ) {
        this.responsesCanned = await this.$store.dispatch(
          "cannedResponses/getCannedResponsesIntegration",
          this.currentDepartment.department_name.toUpperCase()
        );
      }
    },
    async addQuote() {
      this.creating = true;
      this.reloadTable();
      this.creating = false;
    },
    rolConditionTable(user, items, path) {
      return listTableCondition(user, items, path);
    },
    async changeQueue(queueName) {
      this.isBusy = true;
      if (this.currentDepartment.department_id == 2) {
        switch (queueName) {
          case "OTR":
            this.actualQueue = "ftl";
            this.$store.commit("quotes/setActualQueue", this.actualQueue);
            localStorage.setItem("actual-queue", this.actualQueue);
            break;
          case "Drayage":
            this.actualQueue = "drayage";
            this.$store.commit("quotes/setActualQueue", this.actualQueue);
            localStorage.setItem("actual-queue", this.actualQueue);
            break;
        }
        this.getNameDepartment();
        this.setActiveTab();
      } else if (
        this.currentDepartment.department_id == 1 &&
        this.currentDepartment.rol_name == "superuser" &&
        this.$route.params.pathName == "alerts"
      ) {
        switch (queueName) {
          case "Alerts":
            this.alertName = "Alerts";
            break;
          case "Alerts assigned":
            this.alertName = "Alerts assigned";
            break;
        }
      }
      await this.getQuotes();
      await this.getTotalQuotes();
      this.setColor();
      this.filter = null;
      this.isBusy = false;
    },
    setActiveTab() {
      for (let i in this.queueNames) {
        let name;
        switch (this.queueNames[i]) {
          case "OTR":
            name = "otr";
            break;
          case "Drayage":
            name = "drayage";
            break;
        }
        if (name == this.actualQueue) {
          this.queueNamesActive[i] = true;
        } else {
          this.queueNamesActive[i] = false;
        }
      }
    },
    getEntryType(info) {
      if (
        this.currentDepartment.department_id == 2 ||
        this.currentDepartment.department_name == "otr"
      ) {
        if (this.actualQueue == "ftl") {
          info.entry_type = [
            "GRAPH-FTL",
            "GRAPH-HH",
            "GRAPH-SPECIALSERVICES",
            "GRAPH-TEMPCONTROL",
            "SS-Manual",
            "FTL-Manual",
            "HH-Manual",
            "TC-Manual",
            "GRAPH-OTR",
            "OTR-Manual"
          ];
        }
        if (this.actualQueue == "drayage") {
          info.entry_type = ["GRAPH-DRAYAGE", "DRAYAGE-Manual"];
        }
      } else if (
        this.currentDepartment.department_id == 1 ||
        this.currentDepartment.department_name == "ltl"
      ) {
        info.entry_type = [
          "GRAPH",
          "Manual",
          "GRAPH-KNSUPPORT",
          "GRAPH-LATINPRO"
        ];
      }
    },
    getNameDepartment() {
      if (this.currentDepartment.department_id == 2) {
        this.nameDepartment = this.showActualQueue;
      } else {
        this.nameDepartment = this.currentDepartment.department_name;
      }
    },
    setActualQueue() {
      if (this.currentDepartment.department_id == 2) {
        if (localStorage.getItem("actual-queue")) {
          this.actualQueue = localStorage.getItem("actual-queue");
        } else {
          this.actualQueue = "ftl";
        }
        this.$store.commit("quotes/setActualQueue", this.actualQueue);
        localStorage.setItem("actual-queue", this.actualQueue);
      } else {
        this.actualQueue = this.currentDepartment.department_name;
        this.$store.commit("quotes/setActualQueue", this.actualQueue);
      }
    },
    hideModal(subject, content) {
      this.$refs["modal-list-table-content"].show();
      this.contentByIndex = content;
      this.subjectByIndex = subject;
    },
    getValidationAlert(info) {
      if (this.alertName == "Alerts") {
        info.validation_alert = false;
        info.status = 10;
      } else {
        info.validation_alert = true;
        info.status = 2;
      }
      return info;
    },
    hidingOptions() {
      this.hideOptions =
        (this.currentDepartment.department_id == 1 &&
          !this.statusAutoassigner) ||
        this.currentDepartment.department_id != 1;
    },
    validationComponent(nameComponent, index) {
      const isLTLDepartmentId = this.currentDepartment.department_id == 1;
      const isSuperUserRolName = this.currentDepartment.rol_name == "superuser";
      const currentPathNameRoute = this.$route.params.pathName;
      const currentPathRoute = this.$route.path;
      if (
        nameComponent === "assignToButton" ||
        nameComponent === "assignMeButton"
      ) {
        return validateTableComponents(
          nameComponent,
          index,
          isLTLDepartmentId,
          isSuperUserRolName,
          currentPathRoute,
          this.hideOptions,
          this.availableUsers,
          this.items,
          this.alertName
        );
      }
      return validateComponents(
        nameComponent,
        isLTLDepartmentId,
        isSuperUserRolName,
        currentPathNameRoute,
        currentPathRoute,
        this.hideOptions
      );
    },
    async setAlertToSent() {
      const selectedItems =
        this.areAllSelected === "accepted"
          ? this.items
          : this.items.filter((_, i) => this.isChecked[i] === "accepted");

      if (!selectedItems.length) {
        this.swal({
          title: "No items selected",
          text: "Please select at least one alert before proceeding.",
          icon: "warning",
          buttons: false,
          timer: 2500
        });
        return;
      }

      const confirmed = await this.swal({
        title: "Are you sure?",
        text: "The selected alerts will be marked as Sent.",
        icon: "warning",
        buttons: ["Cancel", "Confirm"]
      });
      if (!confirmed) return;
      this.changingStatusSent = true;
      for (const item of selectedItems) {
        if (!item.id) continue;
        await this.$store.dispatch("quotes/updateMessage", {
          messageId: item.id,
          body: { charlie_status: 5 }
        });
      }

      this.areAllSelected = "not_accepted";
      this.changingStatusSent = false;
      await this.getTotalQuotes();
      await this.getQuotes();
      this.setColor();
    }
  }
};
</script>

<style lang="scss" scoped>
.list-table {
  .spinner {
    @include spinner;
  }
  &__mobile-buttons {
    @include flex-wrap(flex-end);
    &__form {
      width: 100%;
      &--clear-button {
        @include primary-button;
        background-color: get-opacity($color-primary-button, 80%) !important;
      }
      &__buttons {
        @include flex-wrap(flex-end);
        margin-top: $margin-most-used;
        &--delete {
          @include primary-button;
          margin-right: $margin-most-used/2;
        }
        &--unassign {
          @include primary-button;
        }
      }
    }
  }
  &__column {
    display: flex;
    flex-direction: column;
  }
  &__table {
    margin-top: $margin-most-used;
    font-size: 13.5px;
    @include box-shadow;
    &__header {
      &__buttons {
        @include flex-wrap(flex-start);
        &--delete {
          @include primary-button;
        }
        &--unassign {
          @include primary-button;
        }
      }
      &--clear-button {
        @include primary-button;
        background-color: get-opacity($color-primary-button, 80%) !important;
      }
    }
    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    &__assign-hypercubes {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    &__button-modal-list-table {
      border: none;
    }
    &__button-hypercubes {
      @include primary-button;
      @include box-shadow;
    }
    &__assign-to {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      &--assigned-to {
        background-color: $color-background-input;
        border-radius: 30px;
        padding: 5px;
        font-size: 13px;
        margin: 0 15px;
        @include box-shadow;
      }
      &--assigned-me {
        border-radius: 50%;
        padding: 5px;
        font-size: 13px;
        @include secondary-button;
      }
    }
  }

  &__pagination {
    @include flex-wrap(center);
    margin-bottom: $margin-most-used;
  }
}

.autocompletes-container {
  display: flex;
  justify-content: space-between;
  padding-left: 5px;
  &__mode {
    width: 50%;
  }
}

.table .thead-light th {
  color: $color-light;
  background-color: $color-background-dark;
  border: none;
  border-radius: 6px 6px 0px 0px;
  padding: 20px 10px;
}

.b-table {
  cursor: pointer;
  border-radius: 6px;
}

::v-deep .table .thead-light th {
  border-radius: 0;
}

.input-group .form-control:not(:last-child),
.input-group .custom-select:not(:last-child) {
  border: none !important;
  color: $color-light;
  background-color: hsla(0, 0%, 100%, 0.125) !important;
}

.input-group .form-control::placeholder {
  color: rgba(171, 178, 185, 0.9) !important;
}

::v-deep
  .custom-switch
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #17a2b8;
}
@media (max-width: 767px) {
  .input-group .form-control:not(:last-child),
  .input-group .custom-select:not(:last-child) {
    border: 1px solid rgba(171, 178, 185, 0.5) !important;
    color: $color-background-dark;
    background-color: $color-background-input !important;
  }
}
</style>
